import type { SynthesisStep } from "@/types/chemistry";

/**
 * Returns the display name for a step.
 * If the step has a user-set name: "Name (N)" where N is the numeric portion of label.
 * If the step has no name: just the label (e.g. "Step 3a").
 */
export function getStepDisplayName(step: Pick<SynthesisStep, "name" | "label">): string {
  const num = step.label.replace(/^Step\s*/i, "");
  if (step.name) {
    return `${step.name} (${num})`;
  }
  return step.label;
}

/**
 * Returns the next default name for a new step using the pattern "Reaction A", "Reaction B", etc.
 * Based on the count of existing steps at creation time.
 */
export function getNextDefaultName(existingSteps: { name?: string }[]): string {
  const count = existingSteps.length;
  // Support up to 26 letters, then AA, AB, etc.
  if (count < 26) {
    return `Reaction ${String.fromCharCode(65 + count)}`;
  }
  const first = String.fromCharCode(65 + Math.floor(count / 26) - 1);
  const second = String.fromCharCode(65 + (count % 26));
  return `Reaction ${first}${second}`;
}
